const state = {
  Rdrawer: false,
  date: "",
  menuopen: false,
  openmodal: false,
  openqualify: false,
  footer: true,
  showSearchCart: true,
  current:''
};

const mutations = {
  date: function(state, date) {
    state.date = date;
  },

  Rdrawer: function(state, Rdrawer) {
    state.Rdrawer = Rdrawer;
  },

  menuopen: function(state, menuopen) {
    state.menuopen = menuopen;
  },
  openmodal: function(state, openmodal) {
    state.openmodal = openmodal;
  },
  openqualify: function(state, openqualify) {
    state.openqualify = openqualify;
  },
  footer: function(state, footer) {
    state.footer = footer;
  },
  showSearchCart: function(state, showSearchCart) {
    state.showSearchCart = showSearchCart;
  },
  set_current: function(state, current) {
    state.current = current;
  },
};

const actions = {};

const getters = {
  drawer_true() {
    return state.Rdrawer;
  },
  today() {
    return state.date;
  },
  MENUOPEN() {
    return state.menuopen;
  },
  OPENMODAL() {
    return state.openmodal;
  },
  OPENQUALIFY() {
    return state.openqualify;
  },
  FOOTER() {
    return state.footer;
  },
  SHOWSEARCHCART() {
    return state.showSearchCart;
  },
  GET_CURRENT() {
    return state.current;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
